import { useCallback } from 'react'
import * as actions from 'client/actions/entityActions'
import { Dispatch } from 'redux'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'

export const useRemoveEntityStyle = (
  dispatch: Dispatch<any>,
  entity: OldEntityInterface,
) => {
  return useCallback(
    (style: OldEntityInterface['styles']) => () => {
      const updatedEntity = {
        ...entity,
        styles: {
          ...entity.styles,
        },
      }

      delete updatedEntity.styles[style]
      dispatch(actions.update(updatedEntity))
    },
    [entity],
  )
}
